var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swipe-wrapper"},[_c('header',{staticClass:"header"},[_c('p',{staticClass:"h-title e-ellipsis-l1"},[_vm._v(_vm._s(_vm.title))]),_c('button',{staticClass:"swipe-back",attrs:{"type":"button"},on:{"click":_vm.back}},[_c('i',{staticClass:"cubeic-back swipe-back-icon"}),_c('span',[_vm._v(_vm._s(_vm.backtxt))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }